import type { UtenteCorrente } from '@aulaviva/shared';
import { useRouteLoaderData } from 'react-router';

/** Utente corrente caricato dal loader dell'area (partecipante o una delle aree di gestione). */
export function useUtenteArea(): UtenteCorrente {
  const area = useRouteLoaderData('area') as UtenteCorrente | undefined;
  const gestione = useRouteLoaderData('gestione') as UtenteCorrente | undefined;
  const relatore = useRouteLoaderData('gestione-relatore') as UtenteCorrente | undefined;
  const regia = useRouteLoaderData('gestione-regia') as UtenteCorrente | undefined;
  const sicurezza = useRouteLoaderData('gestione-sicurezza') as UtenteCorrente | undefined;
  const u = area ?? gestione ?? relatore ?? regia ?? sicurezza;
  if (!u) throw new Error('useUtenteArea fuori da una rotta con loader utente');
  return u;
}
